import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { DataSource } from '../../../services/benchmarkService';
import { dsVar } from '../../../theme/tokens';

/**
 * Institution history or supplied samples.
 *
 * The two answer different questions — how the agent would rank the
 * institution's own caseload, and how it handles alerts someone brought along
 * — so they are never mixed in one list.
 */
const SourceToggle: React.FC<{
    value: DataSource;
    onChange: (value: DataSource) => void;
    fullWidth?: boolean;
}> = ({ value, onChange, fullWidth = false }) => (
    <ToggleButtonGroup
        value={value}
        exclusive
        size="small"
        fullWidth={fullWidth}
        onChange={(_, next: DataSource | null) => next && onChange(next)}
        aria-label="Which benchmark runs to show"
        sx={{
            '.MuiToggleButton-root': {
                fontSize: '0.75rem', fontWeight: 600, color: dsVar('fg-2'),
                borderColor: dsVar('line'), textTransform: 'none', px: 1.5, py: 0.5
            },
            '.Mui-selected': { color: `${dsVar('accent-fg')} !important`, backgroundColor: 'rgba(255,222,89,0.1) !important' }
        }}
    >
        <ToggleButton value="mined">Institution history</ToggleButton>
        <ToggleButton value="user_supplied">Supplied samples</ToggleButton>
    </ToggleButtonGroup>
);

export default SourceToggle;
